import { render } from "./LinkageProfile.vue?vue&type=template&id=dda66ef2&ts=true"
import script from "./LinkageProfile.vue?vue&type=script&lang=ts"
export * from "./LinkageProfile.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1364277118/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__